<div class="container pt-3">
    <form name="accountForm" [formGroup]="accountForm" (ngSubmit)="updateAccount(accountForm.value)" *ngIf="Individual">
        <div class="row">
            <div class="col-12" *ngIf="Individual">
                <h2 class="accent" style="font-size: 0.9970rem">Individual Account </h2>
            </div>

            <div class="col-12" *ngIf="Business">
                <h2 class="accent" style="font-size: 0.9970rem">Business Account </h2>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>NIB Number</mat-label>
                    <input matInput name="NIBNumber" formControlName="NIBNumber" [(ngModel)]="NIBNumber" readonly>
                    <!-- <mat-error *ngIf="enrollForm.controls.NIBNumber.invalid">
                            please Enter NIB Number
                        </mat-error> -->
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-6 pt-sm-3">
                <mat-checkbox (change)="OnCheckboxChange($event)" formControlName="updatePasswordChecked">Update
                    Password</mat-checkbox>
            </div>

            <div class="col-6" *ngIf="updatePassword">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Password</mat-label>
                    <input matInput formControlName="NewPassword" type="password">
                    <mat-error *ngIf="accountForm.controls.NewPassword.invalid">
                        Password should contain at least one uppercase letter, one lowercase letter, one number and one
                        special character and minimum
                        8 and maximum 12 characters,
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-6" *ngIf="updatePassword">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>ConfirmPassword</mat-label>
                    <input matInput formControlName="ConfirmPassword" type="password">
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>First Name</mat-label>
                    <input matInput name="Firstname" [(ngModel)]="FirstName" formControlName="FirstName"
                        autocomplete="off">
                    <!-- <mat-error *ngIf="enrollForm.controls.FirstName.invalid">
                            please Enter First Name
                        </mat-error>    [ngModel]="userEmail" formControlName="UserEmail"-->
                </mat-form-field>
            </div>


            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Middle Name</mat-label>
                    <input matInput name="MiddleName" [(ngModel)]="MiddleName" formControlName="MiddleName"
                        autocomplete="off">
                    <!-- <mat-error *ngIf="enrollForm.controls.MiddleName.invalid">
                            please Enter Middle Name
                        </mat-error> -->
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Last Name</mat-label>
                    <input matInput name="LastName" [(ngModel)]="LastName" formControlName="LastName">
                    <!-- <mat-error *ngIf="enrollForm.controls.LastName.invalid">
                            please Enter Last Name
                        </mat-error> -->
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Email</mat-label>
                    <input matInput name="Email" [(ngModel)]="Email" formControlName="Email">
                    <!-- <mat-error *ngIf="enrollForm.controls.Email.invalid">
                            please Enter Email
                        </mat-error> -->
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100 mb-1">
                    <mat-label>Phone Number <label style="color:red">*</label></mat-label>
                    <input matInput name="IndividualPhone" [(ngModel)]="phone" formControlName="IndividualPhone" autocomplete="off"
                        readonly>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100 mb-1">
                    <mat-label>Address <label style="color:red">*</label></mat-label>
                    <textarea matInput formControlName="IndividualAddress" name="IndividualAddress" [(ngModel)]="address" type="text"
                        readonly></textarea>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100 mb-1">
                    <mat-label>Occupation/Source of Income </mat-label>
                    <input matInput formControlName="Occupation" name="Occupation" [(ngModel)]="Occupation"
                        autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4"  *ngIf=drivingLincenceNumberEnable>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Driver’s License & InsuranceCard Number</mat-label>
                    <input matInput name="PassportNumber" [(ngModel)]="PassportNumber" formControlName="PassportNumber">
                    <!-- <mat-error *ngIf="enrollForm.controls.PassportNumber.invalid">
                            please Enter Passport Number
                        </mat-error> -->
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4"  *ngIf=passportNumberEnable>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Passport Number</mat-label>
                    <input matInput name="PassportNumber" [(ngModel)]="PassportNumber" formControlName="PassportNumber">
                    <!-- <mat-error *ngIf="enrollForm.controls.PassportNumber.invalid">
                            please Enter Passport Number
                        </mat-error> -->
                </mat-form-field>
            </div>

           





            <div class="col-12 col-sm-4" *ngIf="expirydate">
                <mat-form-field appearance="outline" class="w-100 mb-1">
                    <mat-label>Expiration Date</mat-label>
                    <input matInput [matDatepicker]="picker1" formControlName="Expirydate" name="expirydate"
                        [(ngModel)]="clientdata.expiryDate" autocomplete="off" readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4">
                <mat-form-field *ngIf="expirydates" appearance="outline" class="w-100 mb-1">
                    <mat-label>Expiration Date</mat-label>

                    <input matInput [matDatepicker]="picker1" formControlName="Expirydate" name="expirydate"
                        placeholder="MM/DD/YYYY">
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </div>

        </div>
        <div class="row">
            <div class="col-12 col-sm-4" *ngIf="Date">
                <mat-form-field appearance="outline" class="w-100 mb-1">
                    <mat-label>Birthday</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="Birthday" name="date"
                        [(ngModel)]="clientdata.birthday" autocomplete="off" readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <!-- Request -->
            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100 mb-1">
                    <mat-label>Request <label style="color:red">*</label></mat-label>
                    <textarea matInput formControlName="request" name="request" type="text"
                        [(ngModel)]="request"></textarea>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4">
                <mat-form-field *ngIf="Dates" appearance="outline" class="w-100 mb-1">
                    <mat-label>Birthday</mat-label>

                    <input matInput [matDatepicker]="picker" formControlName="Birthday" name="date">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>


        </div>

        <div class="col-12 col-sm-4"></div>
        <div class="col-8" *ngIf="hidebankdetails">
            <h4 style="font-size: 0.9970rem"> Banking Info<label style="color:red"> </label> </h4>

            <div class="row">
                <div class="col-12 col-sm-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Bank Name </mat-label>
                        <input matInput formControlName="bankname" [(ngModel)]="bankname" name="bankname">
                    </mat-form-field>
                </div>

                <div class="col-12 col-sm-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Branch </mat-label>
                        <input matInput formControlName="branch" [(ngModel)]="branch" name="branch">
                    </mat-form-field>
                </div>

                <div class="col-12 col-sm-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Account Number </mat-label>
                        <input matInput formControlName="accountnumber" [(ngModel)]="accountnumber"
                            name="accountnumber">
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-4"></div>



        <div class="row" *ngIf="uploadpassportfiles">
            <div class="col-12">
                <h4 style="font-size: 0.9970rem"> Upload Passport</h4>
            </div>

            <div class="col-auto pb-2">
                <mat-chip-list aria-label="Files">
                    <mat-chip *ngIf="Passport" matTooltip="Overwrite" (click)="btnclickevent1()">
                        File Uploaded
                        <mat-icon class="mat-chip-remove mat-chip-trailing-icon">cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
            </div>

            <div class="col-12">
                <div class="input-group w-100 mb-2" *ngIf="!Passport">
                    <div class="custom-file">
                        <input type="file" id="inputGroupFile03" aria-describedby="inputGroupFileAddon03"
                            (change)="onFileChange($event)" accept="image/jpg,image/jpeg,application/pdf"
                            formControlName="passportFile">
                        <label class="custom-file-label" for="inputGroupFile03">{{this.fileInput}}</label>

                    </div>
                </div>
            </div>
            <!-- <div class="col-12">
                <button mat-flat-button type="submit" color="primary" class="loginbtn mr-2">Save</button>&nbsp;
            </div> -->
        </div>


        <div class="row" *ngIf="UploadNationalInsurancefiles">
            <div class="col-12">
                <h4 style="font-size: 0.9970rem">Upload Driver’s License</h4>
            </div>

            <div class="col-auto pb-2">
                <mat-chip-list aria-label="Files">

                    <!-- <mat-chip *ngIf="DriversLicense" matTooltip="Overwrite" (click)="btnclickevent2()"> -->

                    <mat-chip *ngIf="DriversLicense">
                        File Uploaded
                        <mat-icon class="mat-chip-remove mat-chip-trailing-icon">cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
            </div>

            <div class="col-12">
                <div class="input-group w-100 mb-2" *ngIf="!DriversLicense">
                    <div class="custom-file">
                        <input type="file" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01"
                            (change)="onFileChangeDriversLicense($event)" accept="image/jpg,image/jpeg,application/pdf"
                            formControlName="passportFile">
                        <label class="custom-file-label" for="inputGroupFile01">{{this.DriversLicensefileInput}}</label>

                    </div>
                </div>
            </div>&nbsp;


            <div class="col-12">
                <h4 style="font-size: 0.9970rem">Upload National Insurance Card</h4>
            </div>

            <div class="col-auto pb-2">
                <mat-chip-list aria-label="Files">
                    <mat-chip *ngIf="National">
                        File Uploaded
                        <mat-icon class="mat-chip-remove mat-chip-trailing-icon">cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
            </div>

            <div class="col-12">
                <div class="input-group w-100 mb-2" *ngIf="!National">
                    <div class="custom-file">
                        <input type="file" id="inputGroupFile02" aria-describedby="inputGroupFileAddon02"
                            (change)="onFileChangeNationalInsuranceCard($event)"
                            accept="image/jpg,image/jpeg,application/pdf" formControlName="passportFile">
                        <label class="custom-file-label"
                            for="inputGroupFile02">{{this.NationalInsuranceCardfileInput}}</label>
                    </div>
                </div>
            </div>

        </div>


        <!-- With out uploaded file then enable to the upload option -->
        <div class="col-12 col-sm-4" *ngIf="!uploadpassportfiles &&  !UploadNationalInsurancefiles">
            <h6 style="font-size: 0.9970rem"><strong >Identification Type <label style="color:red">*</label></strong></h6>
            <div class="radiobtn">
                <mat-radio-group name="submissiontype" (change)="IdentificationradioChange($event)" class="row">
                    <mat-radio-button value="0" color="primary">
                        Passport
                    </mat-radio-button>
                    <mat-radio-button value="1" color="primary">Driver’s
                        License AND National Insurance Card
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>


        <div class="col-12" *ngIf="reuploadpassportfiles">
            <h4 style="font-size: 0.9970rem">Upload Passport
                <span class="text-muted"> <label style="color:red">
                        <h5>(JPG and PDF files are allowed)</h5>
                    </label></span>
            </h4>
            <div class="input-group w-100 mb-2">
                <div class="custom-file">
                    <input type="file" id="inputGroupFile03" aria-describedby="inputGroupFileAddon03"
                        (change)="onFileChange($event)" accept="image/jpg,image/jpeg,application/pdf"
                        formControlName="passportFile">

                    <label class="custom-file-label" for="inputGroupFile03">{{this.fileInput}}</label>

                </div>
            </div>
        </div>


        <div class="col-12" *ngIf="reUploadNationalInsurancefiles">
            <h4 style="font-size: 0.9970rem"> Upload Driver’s License
                <span class="text-muted"> <label style="color:red">
                        <h5 style="font-size: 0.9970rem">(JPG and PDF files are allowed)</h5>
                    </label></span>
            </h4>
            <div class="input-group w-100 mb-2">
                <div class="custom-file">
                    <input type="file" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01"
                        (change)="onFileChangeDriversLicense($event)" accept="image/jpg,image/jpeg,application/pdf"
                        formControlName="passportFile">
                    <label class="custom-file-label" for="inputGroupFile01">{{this.DriversLicensefileInput}}</label>
                </div>
            </div>&nbsp;


            <h4 style="font-size: 0.9970rem"> Upload National Insurance Card
                <span class="text-muted"> <label style="color:red">
                        <h5 style="font-size: 0.9970rem">(JPG and PDF files are allowed)</h5>
                    </label></span>
            </h4>
            <div class="input-group w-100 mb-2">
                <div class="custom-file">
                    <input type="file" id="inputGroupFile02" aria-describedby="inputGroupFileAddon02"
                        (change)="onFileChangeNationalInsuranceCard($event)"
                        accept="image/jpg,image/jpeg,application/pdf" formControlName="passportFile">
                    <label class="custom-file-label"
                        for="inputGroupFile02">{{this.NationalInsuranceCardfileInput}}</label>


                </div>
            </div>

        </div>

        <div class="col-12">
            <!-- <button mat-flat-button type="submit" color="primary" class="loginbtn mr-2">Save</button>&nbsp; -->
            <button mat-flat-button type="submit" color="primary" class="loginbtn mr-2">Request Change</button>&nbsp;

        </div>

    </form>















    <!-- Business -->


    <form name="businessaccountForm" [formGroup]="businessaccountForm"
        (ngSubmit)="updateBusinessAccount(businessaccountForm.value)" *ngIf="Business">
        <div class="row">
            <div class="col-12" *ngIf="Individual">
                <h2 class="accent" style="font-size: 0.9970rem">Individual Account </h2>
            </div>

            <div class="col-12" *ngIf="Business">
                <h2 class="accent" style="font-size: 0.9970rem">Business Account </h2>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>NIB Number</mat-label>
                    <input matInput name="ID" formControlName="ID" [(ngModel)]="IdNumber" readonly>

                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Business Name <label style="color:red">*</label></mat-label>
                    <input matInput name="Bname" formControlName="Bname" [(ngModel)]="BusinessName" readonly>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Trading As (optional) </mat-label>
                    <input matInput name="trading" formControlName="trading" [(ngModel)]="Trading">
                </mat-form-field>
            </div>

            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100 ">
                    <mat-label>Business Type <label style="color:red">* </label></mat-label>
                    <input matInput name="Btype" formControlName="Btype" [(ngModel)]="BusinessType" readonly>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label> Business Address <label style="color:red">*</label></mat-label>
                    <textarea matInput formControlName="Baddress" name="Baddress" type="text"
                        [(ngModel)]="BusinessAddress" readonly></textarea>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label> Business Email Address <label style="color:red">*</label></mat-label>
                    <input matInput formControlName="Bemailaddress" name="Bemailaddress" [(ngModel)]="BusinessEmail"
                        readonly>
                </mat-form-field>

            </div>



            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100 mb-1">
                    <mat-label>Date of Inception</mat-label>
                    <input matInput [matDatepicker]="picker1" formControlName="DateofInception" name="DateofInception"
                    [(ngModel)]="dbDate" autocomplete="off" readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </div>


        </div>
        <!-- Primary Contacts -->

        <div class="col-8">
            <h4 style="font-size: 0.9970rem"> Primary Contacts<label style="color:red"> </label> </h4>

            <div class="row">
                <div class="col-12 col-sm-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label> Name <label style="color:red">*</label></mat-label>
                        <input matInput formControlName="BPname" name="BPname" [(ngModel)]="PrimaryName" readonly>
                    </mat-form-field>
                </div>

                <div class="col-12 col-sm-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label> Email Address <label style="color:red">*</label></mat-label>
                        <input matInput formControlName="BPemailaddress" name="BPemailaddress"
                            [(ngModel)]="PrimaryEmail" readonly>
                    </mat-form-field>
                </div>

                <div class="col-12 col-sm-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label> Phone <label style="color:red">*</label></mat-label>
                        <input matInput formControlName="BPphone" name="BPphone" [(ngModel)]="PrimaryPhone" readonly>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <!-- Secondary Contacts -->
        <div class="col-8">
            <h4 style="font-size: 0.9970rem"> Secondary Contacts </h4>

            <div class="row">
                <div class="col-12 col-sm-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label> Name </mat-label>
                        <input matInput formControlName="SBname" name="SBname" [(ngModel)]="SecondaryName" readonly>
                    </mat-form-field>
                </div>

                <div class="col-12 col-sm-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label> Email Address</mat-label>
                        <input matInput formControlName="SBemailaddress" name="SBemailaddress"
                            [(ngModel)]="SecondaryEmail" readonly>
                    </mat-form-field>
                </div>

                <div class="col-12 col-sm-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label> Phone </mat-label>
                        <input matInput formControlName="SBphone" name="SBphone" [(ngModel)]="SecondaryPhone" readonly>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-4"></div>
        <div class="col-8">
            <h4 style="font-size: 0.9970rem"> Banking Info<label style="color:red"> </label> </h4>

            <div class="row">
                <div class="col-12 col-sm-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Bank Name </mat-label>
                        <input matInput formControlName="bankname" [(ngModel)]="bankname" name="bankname" readonly>
                    </mat-form-field>
                </div>

                <div class="col-12 col-sm-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Branch </mat-label>
                        <input matInput formControlName="branch" [(ngModel)]="branch" name="branch" readonly>
                    </mat-form-field>
                </div>

                <div class="col-12 col-sm-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Account Number </mat-label>
                        <input matInput formControlName="accountnumber" [(ngModel)]="accountnumber" name="accountnumber"
                            readonly>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-4"></div>



        <!-- //Document 2 -->
        <div class="row">
            <div class="col-12">
                <h4 style="font-size: 0.9970rem">Beneficial Owner details (articles of incorporation or equivalent)</h4>
            </div>

            <div class="col-auto pb-2">
                <mat-chip-list aria-label="Files">
                    <mat-chip *ngIf="Passport">
                        File Uploaded
                        <mat-icon class="mat-chip-remove mat-chip-trailing-icon">cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
            </div>

            <div class="col-12">
                <div class="input-group w-100 mb-2" *ngIf="!Passport">
                    <div class="custom-file">
                        <input type="file" id="inputGroupFile03" aria-describedby="inputGroupFileAddon03"
                            (change)="onFileChange($event)" accept="image/jpg,image/jpeg,application/pdf"
                            formControlName="passportFile">
                        <label class="custom-file-label" for="inputGroupFile03">{{this.fileInput}}</label>

                    </div>
                </div>
            </div>


            <!-- //Document 2 -->
            <div class="col-12">
                <h4 style="font-size: 0.9970rem">Authorized Signatories and specimen signatures</h4>
            </div>

            <div class="col-auto pb-2">
                <mat-chip-list aria-label="Files">
                    <mat-chip *ngIf="Passport">
                        File Uploaded
                        <mat-icon class="mat-chip-remove mat-chip-trailing-icon">cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
            </div>

            <div class="col-12">
                <div class="input-group w-100 mb-2" *ngIf="!Passport">
                    <div class="custom-file">
                        <input type="file" id="inputGroupFile03" aria-describedby="inputGroupFileAddon03"
                            (change)="onFileChange($event)" accept="image/jpg,image/jpeg,application/pdf"
                            formControlName="passportFile">
                        <label class="custom-file-label" for="inputGroupFile03">{{this.fileInput}}</label>

                    </div>
                </div>
            </div>



            <!-- //Document 3 -->
            <div class="col-12">
                <h4 style="font-size: 0.9970rem">Business license/VAT registration</h4>
            </div>

            <div class="col-auto pb-2">
                <mat-chip-list aria-label="Files">
                    <mat-chip *ngIf="Passport">
                        File Uploaded
                        <mat-icon class="mat-chip-remove mat-chip-trailing-icon">cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
            </div>

            <div class="col-12">
                <div class="input-group w-100 mb-2" *ngIf="!Passport">
                    <div class="custom-file">
                        <input type="file" id="inputGroupFile03" aria-describedby="inputGroupFileAddon03"
                            (change)="onFileChange($event)" accept="image/jpg,image/jpeg,application/pdf"
                            formControlName="passportFile">
                        <label class="custom-file-label" for="inputGroupFile03">{{this.fileInput}}</label>

                    </div>
                </div>
            </div>


        </div>

    </form>
    <div class="mat-spinner-fullscreen" [hidden]="loadingData1">
        <mat-spinner style="margin:0 auto;" class="pink-spinner .mat-spinner-bar-buffer" mode="indeterminate">
        </mat-spinner>
    </div>
</div>
